import React, { useState } from "react";
import { Box, Card, CardContent, Typography, Chip, Grid, Avatar } from "@mui/material";
import { format } from "date-fns";

const ManagerIncompleteTaskCard = ({ tasks, onTaskClick, staffDebriefs, childDebriefs, roomSearches, statements }) => {
  const [expandedTask, setExpandedTask] = useState(null);

  const handleToggleExpand = (index) => {
    setExpandedTask(expandedTask === index ? null : index);
  };

  return (
    <Box sx={{ mb: 4 }}>
      {tasks.map((task, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(task); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task
            }}
          >
            <CardContent>
              <Grid container>
                <Grid item lg={10} md={9}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        {task.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{task.description}</Typography>
                  <Grid item>
                    <Chip
                      variant='contained'
                      sx={{
                        fontSize: "12px",
                        borderRadius: 5,
                        backgroundColor: task.status === "completed" ? "#EAFFF2" : "#FFDDCC",
                        color: task.status === "completed" ? "green" : "red",
                      }}
                      label={task?.status}
                      size='small'
                    />
                  </Grid>
                </Grid>
                <Grid item lg={2} md={3}>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                    </Grid>
                    <Grid item>
                      <Chip
                        variant='contained'
                        sx={{
                          fontSize: "12px",
                          borderRadius: 5,
                          backgroundColor: task.assignee && task.assignee !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                          color: task.assignee && task.assignee !== "unassigned" ? "green" : "blue",
                        }}
                        label={task.assignee ?? "unassigned"}
                        size='small'
                      />
                    </Grid>
                  </Grid>
                  <br />
                  <Typography sx={{ fontSize: "12px" }}>
                    {task?.timeline === "daily"
                      ? format(new Date(task.created_at), "dd EEE")
                      : `${format(new Date(task.created_at), "dd EEE")} - ${format(
                          new Date(new Date(task.created_at).setDate(new Date(task.created_at).getDate() + 6)),
                          "dd EEE"
                        )}`}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
      {statements?.map((statement, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(statement); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item lg={8} md={8}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        {statement?.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{statement?.description}</Typography>
                  <Grid item>
                    <Chip
                      variant='contained'
                      sx={{
                        fontSize: "12px",
                        borderRadius: 5,
                        backgroundColor: statement.status === "completed" ? "#EAFFF2" : "#FFDDCC",
                        color: statement.status === "completed" ? "green" : "red",
                      }}
                      label={statement?.status}
                      size='small'
                    />
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4}>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                        </Grid>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor:
                                statement?.assignee && statement?.assignee !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                              color: statement?.assignee && statement?.assignee !== "unassigned" ? "green" : "blue",
                            }}
                            label={statement?.assignee ?? "unassigned"}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ fontSize: "12px" }}>
                        {format(new Date(statement?.created_at), "dd MMM yyyy")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
      {roomSearches?.map((roomSearch, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(roomSearch); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item lg={8} md={8}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        {roomSearch?.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{roomSearch?.description}</Typography>
                  <Grid item>
                    <Chip
                      variant='contained'
                      sx={{
                        fontSize: "12px",
                        borderRadius: 5,
                        backgroundColor: roomSearch.status === "completed" ? "#EAFFF2" : "#FFDDCC",
                        color: roomSearch.status === "completed" ? "green" : "red",
                      }}
                      label={roomSearch?.status}
                      size='small'
                    />
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4}>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                        </Grid>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor:
                                roomSearch?.assignee && roomSearch?.assignee !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                              color: roomSearch?.assignee && roomSearch?.assignee !== "unassigned" ? "green" : "blue",
                            }}
                            label={roomSearch?.assignee ?? "unassigned"}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ fontSize: "12px" }}>
                        {format(new Date(roomSearch?.created_at), "dd MMM yyyy")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
      {staffDebriefs.map((staffDebrief, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(staffDebrief); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item lg={8} md={8}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        {staffDebrief?.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{staffDebrief?.description}</Typography>
                  <Grid item>
                    <Chip
                      variant='contained'
                      sx={{
                        fontSize: "12px",
                        borderRadius: 5,
                        backgroundColor: staffDebrief.status === "completed" ? "#EAFFF2" : "#FFDDCC",
                        color: staffDebrief.status === "completed" ? "green" : "red",
                      }}
                      label={staffDebrief?.status}
                      size='small'
                    />
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4}>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                        </Grid>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor:
                                staffDebrief?.assignee && staffDebrief?.assignee !== "unassigned"
                                  ? "#EAFFF2"
                                  : "#F2F6FF",
                              color:
                                staffDebrief?.assignee && staffDebrief?.assignee !== "unassigned" ? "green" : "blue",
                            }}
                            label={staffDebrief?.assignee ?? "unassigned"}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ fontSize: "12px" }}>
                        {format(new Date(staffDebrief?.created_at), "dd MMM yyyy")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
      {childDebriefs.map((childDebrief, index) => {
        return (
          <Card
            sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
            onClick={() => {
              onTaskClick(childDebrief); // Trigger the task click handler
              handleToggleExpand(index); // Toggle expansion for the task
            }}
          >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item lg={8} md={8}>
                  <Grid container spacing={1} mb={1}>
                    <Grid item>
                      <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                        {childDebrief?.taskName}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Typography sx={{ fontSize: "12px", color: "black" }}>{childDebrief?.description}</Typography>
                  <Grid item>
                    <Chip
                      variant='contained'
                      sx={{
                        fontSize: "12px",
                        borderRadius: 5,
                        backgroundColor: childDebrief.status === "completed" ? "#EAFFF2" : "#FFDDCC",
                        color: childDebrief.status === "completed" ? "green" : "red",
                      }}
                      label={childDebrief?.status}
                      size='small'
                    />
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4}>
                  <Grid container justifyContent='space-between' alignItems='center'>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                        </Grid>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor:
                                childDebrief?.assignee && childDebrief?.assignee !== "unassigned"
                                  ? "#EAFFF2"
                                  : "#F2F6FF",
                              color:
                                childDebrief?.assignee && childDebrief?.assignee !== "unassigned" ? "green" : "blue",
                            }}
                            label={childDebrief?.assignee ?? "unassigned"}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Typography sx={{ fontSize: "12px" }}>
                        {format(new Date(childDebrief?.created_at), "dd MMM yyyy")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default ManagerIncompleteTaskCard;
